import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app"; // Importa o App.jsx
import "./index.css"; // Importa o arquivo de estilos globais

// Cria a raiz da aplicação e renderiza o componente App
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);